import { useState, useRef } from 'react'
import { toastErrorLog } from '../../helpers/toastErrorLog'
import { useAuth } from '../../hooks/useAuth'
import * as ContactoService from '../servicios/contactoService'
import styles from './MensajeContacto.module.css'

const Contacto = () => {
  const { loginDataContext: { empid } = {} } = useAuth()
  const [msgForm, setMsgForm] = useState({
    usuario: localStorage.getItem('usuario'),
    empid,
    nombre: '',
    email: '',
    mensaje: ''
  })
  const [sucess, setSucess] = useState(false)

  const form = useRef()

  const handleSubmit = async (e) => {
    try {
      e.preventDefault()
      await ContactoService.enviarMensaje(msgForm)
      form.current.reset()
      setSucess(true)
    } catch (error) {
      const mensaje = `Ocurrió un error al enviar el mensaje.`
      toastErrorLog(error, mensaje, 'contacto')
    }
  }

  const handleChange = (e) => {
    setMsgForm({ ...msgForm, [e.target.name]: e.target.value })
  }
  return (
    <div className={styles.card}>
      <form onSubmit={handleSubmit} ref={form}>
        <div className={styles.campo}>
          <label className={styles.label} htmlFor="nombre">
            Nombre
          </label>
          <input
            id="nombre"
            name="nombre"
            className={styles.input}
            type="text"
            required
            onChange={handleChange}
          />
        </div>
        <div className={styles.campo}>
          <label className={styles.label} htmlFor="email">
            E-mail
          </label>
          <input
            id="email"
            name="email"
            className={styles.input}
            type="email"
            required
            onChange={handleChange}
          />
        </div>
        <div className={styles.campo}>
          <label className={styles.label} htmlFor="mensaje">
            ¿En qué podemos ayudarlo?
          </label>
          <textarea
            id="mensaje"
            name="mensaje"
            className={styles.textarea}
            required
            onChange={handleChange}
          ></textarea>
        </div>
        <button type="submit" className={styles.btnEnviar}>
          Enviar Comentarios
        </button>
      </form>
      {sucess && (
        <div className={styles.mensajeExito}>
          Sus comentarios han sido enviados, Muchas gracias.
        </div>
      )}
    </div>
  )
}
export default Contacto
